import { render, staticRenderFns } from "./CarRecord.vue?vue&type=template&id=44505a12&scoped=true&"
import script from "./CarRecord.vue?vue&type=script&lang=js&"
export * from "./CarRecord.vue?vue&type=script&lang=js&"
import style0 from "./CarRecord.vue?vue&type=style&index=0&id=44505a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44505a12",
  null
  
)

export default component.exports